import { useState } from 'react'
import { useFriends } from '../hooks/useFriends'
import Loader from '../components/common/Loader'
import './Friends.css'

function Friends() {
  const { friends, loading, error, addFriend, removeFriend } = useFriends()
  const [email, setEmail] = useState('')
  const [adding, setAdding] = useState(false)
  const [addError, setAddError] = useState(null)
  const [success, setSuccess] = useState(null)

  const handleAddFriend = async (e) => {
    e.preventDefault()
    if (!email.trim()) return

    setAdding(true)
    setAddError(null)
    setSuccess(null)

    try {
      const friend = await addFriend(email.trim())
      setEmail('')
      setSuccess(`${friend.friendName} agregado como amigo`)
      setTimeout(() => setSuccess(null), 3000)
    } catch (err) {
      setAddError(err.message)
    } finally {
      setAdding(false)
    }
  }

  const handleRemoveFriend = async (friendId, friendName) => {
    if (!confirm(`¿Eliminar a ${friendName} de tus amigos?`)) return
    
    try {
      await removeFriend(friendId)
    } catch (err) {
      console.error('Error removing friend:', err)
    }
  }

  if (loading) {
    return <Loader fullScreen />
  }

  return (
    <div className="page friends-page">
      <div className="container">
        <div className="page-header">
          <h1 className="page-title">👥 Amigos</h1>
          <p className="text-secondary">
            Agrega amigos para registrar con quién ves películas
          </p>
        </div>

        {/* Add Friend Form */}
        <div className="add-friend-card">
          <h2>Agregar amigo</h2>
          <form onSubmit={handleAddFriend} className="add-friend-form">
            <input
              type="email"
              className="input"
              placeholder="Email de tu amigo"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={adding}
            />
            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={adding || !email.trim()}
            >
              {adding ? 'Agregando...' : 'Agregar'}
            </button>
          </form>

          {addError && (
            <div className="friend-message friend-error">
              ❌ {addError}
            </div>
          )}

          {success && (
            <div className="friend-message friend-success">
              ✅ {success}
            </div>
          )}
        </div>

        {/* Friends List */}
        <div className="friends-section">
          <h2>Tus amigos ({friends.length})</h2>
          
          {friends.length === 0 ? (
            <div className="empty-state">
              <div className="empty-state-icon">👥</div>
              <p>Aún no tienes amigos agregados</p>
              <p className="text-sm text-muted">
                Agrega amigos por su email para registrar con quién ves películas
              </p>
            </div>
          ) : (
            <div className="friends-list">
              {friends.map(friend => (
                <div key={friend.id} className="friend-item">
                  <div className="friend-avatar">
                    {friend.friendName?.charAt(0)?.toUpperCase() || '?'}
                  </div>
                  <div className="friend-info">
                    <span className="friend-name">{friend.friendName}</span>
                    <span className="friend-email">{friend.friendEmail}</span>
                  </div>
                  <button
                    className="btn btn-ghost friend-remove"
                    onClick={() => handleRemoveFriend(friend.id, friend.friendName)}
                    title="Eliminar amigo"
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Friends
